import { useEffect, useState } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { CHECKLIST_TEMPLATES } from '../constants';

// Returns checklist templates merged from Firestore overrides + constant defaults.
// Firestore docs override the matching incident type; unmatched types use constants.
export function useChecklistTemplates() {
  const [templates, setTemplates] = useState(CHECKLIST_TEMPLATES);

  useEffect(() => {
    return onSnapshot(collection(db, 'checklistTemplates'), (snap) => {
      if (snap.empty) { setTemplates(CHECKLIST_TEMPLATES); return; }
      const overrides = {};
      snap.docs.forEach((d) => { overrides[d.id] = d.data().items || []; });
      setTemplates({ ...CHECKLIST_TEMPLATES, ...overrides });
    });
  }, []);

  return templates;
}
